import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { PageHero, Section, SectionHeading, Seo, Reveal, breadcrumb } from "@/components/site/Section";
import { PostcodeChecker } from "@/components/site/PostcodeChecker";
import { ZoneList, FinalCTA } from "@/components/site/HomeSections";
import { useZones } from "@/lib/api";
import SEO from "@/data/seo-pages.json";

export default function DeliveryAreas() {
  const { hash } = useLocation();
  const { data } = useZones();
  useEffect(() => {
    if (hash === "#check") setTimeout(() => document.getElementById("area-postcode-input")?.focus(), 400);
  }, [hash]);

  return (
    <>
      <Seo title="Log Delivery Areas: Newtownabbey, Glengormley, Carrickfergus, Ballyclare" path="/delivery-areas" description="WeeLogRun delivers kiln-dried firewood to Newtownabbey, Glengormley, Jordanstown, Carrickfergus and Ballyclare (BT36, BT37, BT38, BT39). Check your postcode." jsonLd={breadcrumb("Delivery Areas", "/delivery-areas")} />
      <PageHero eyebrow="Delivery areas" title="Do we deliver to you?" intro="Enter your full postcode below. We currently deliver across BT36, BT37, BT38 and BT39.">
        <div id="check" className="mt-10 max-w-2xl scroll-mt-28">
          <PostcodeChecker idPrefix="area-postcode" />
        </div>
      </PageHero>
      <Section>
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHeading eyebrow="Where we deliver" title="Current delivery districts." intro="Not on the list yet? Check your postcode and join the waiting list — it helps us decide where to go next." />
          </div>
          <Reveal delay={0.1} className="lg:col-span-7 space-y-6">
            <ZoneList />
            <p className="text-[15px] leading-relaxed text-[#A1A1AA]" data-testid="delivery-areas-seo-copy">
              We deliver kiln-dried logs, kindling and firelighters to homes in Newtownabbey, Glengormley, Jordanstown, Whiteabbey, Greenisland, Carrickfergus, Whitehead,
              Ballyclare, Templepatrick, Doagh and the surrounding villages across BT36, BT37, BT38 and BT39 — straight to your door, every month.
            </p>
            <div className="grid gap-3 sm:grid-cols-2" data-testid="delivery-area-pages">
              {SEO.areas.map((a) => (
                <Link key={a.slug} to={`/log-delivery/${a.slug}`} className="lc-card p-4 transition-colors hover:border-[#FF6A00]" data-testid={`delivery-area-page-${a.slug}`}>
                  <span className="font-semibold text-[#F7F5F0]">{a.name} <span className="text-[#D4A437]">{a.postcode}</span></span>
                  <span className="mt-1 block text-xs text-[#A1A1AA]">{a.towns.join(", ")}</span>
                </Link>
              ))}
            </div>
            <p className="rounded-2xl border border-[#262626] bg-[#0f0f0f] p-5 text-sm text-[#A1A1AA]" data-testid="delivery-schedule-note">
              {data?.schedule_configured && data.delivery_days?.length
                ? `Delivery days: ${data.delivery_days.join(", ")}.`
                : "Delivery days are planned by area. We'll confirm your delivery day by email once your subscription is set up."}
            </p>
          </Reveal>
        </div>
      </Section>
      <FinalCTA />
    </>
  );
}
